import { ExpandLess, ExpandMore } from '@mui/icons-material';
import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { fetchPersonalDataIfNeeded, fetchPersonalDetails } from '../../actions/personalDetails'
import AddressType from '../../enums/AddressType'
import Country from '../../enums/Country'
import {
  getContactAddressFields,
  getPermanentAddressFields,
  getTooltipBySlug,
  isInternationalOnshoreStudent,
  isSameAddress,
  mergeContactDetails,
  mergePermanentDetails,
  stripPhoneNumber
} from '../../helpers/form'
import { getHelperTextForPage, getTooltipsForPage } from '../../services/reservoir'
import { getReferences, putPersonalDetails, getPronounsDetails, getAffirmedGenderDetails, postValidateAddress, postAddressSearch } from '../../services/vu'
import CalloutBox from '../tags/CalloutBox'
import HelpText from '../tags/HelpText'
import Loading from '../tags/Loading'
import SettingsForm from '../tags/SettingsForm'
import Phone from '../../enums/Phone'
import AddressValidationStatus from '../../enums/AddressValidationStatus';
import Modal from '../tags/Modal';
import ConfirmationModal from '../tags/ConfirmationModal';
import AddressMatchTypes from '../../enums/AddressMatchTypes';
import { normalizeWhitespace } from '../../helpers/validation';


const dateFormat = { year: 'numeric', month: 'short', day: 'numeric' }

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, personalDetails }) => {
  return {
    courseId: selectedCourseCode,
    personalDetails: personalDetails.data,
    receivedAt: personalDetails.receivedAt,
    isOffshoreFlag: selectedCourse.isOffshoreFlag
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchPersonalDetails: () => {
      dispatch(fetchPersonalDataIfNeeded())
    },
    refetchPersonalDetails: () => {
      dispatch(fetchPersonalDetails())
    }
  }
}

export class Settings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formLoaded: false,
      saving: false,
      excludedCountries: [{ countryCode: 'YCJ', countryDescription: 'AUSTRALIAN ANTARCTIC TERRITORY' }, { countryCode: 'XTJ', countryDescription: 'AUSTRALIAN EXTERNAL TERRITORIES' }],
      form: {
        preferredName: '',
        chosenFirstName: '',
        chosenLastName: '',
        chosenPronouns: '',
        chosenAffirmedGender: '',
        mobileNumber: '',
        homePhoneNumber: '',
        emailAddress: '',

        permanentCountry: '',
        permanentAddressLine1: '',
        permanentAddressLine2: '',
        permanentAddressLine3: '',
        permanentSuburb: '',
        permanentState: '',
        permanentPostcode: '',
        permanentHasAddressChanged: false,
        insertPermanentAddressManually: false,

        knowsAustralianAddress: 'N',
        contactAddressSameAsPermanentAddress: false,
        contactCountry: '',
        contactAddressLine1: '',
        contactAddressLine2: '',
        contactAddressLine3: '',
        contactSuburb: '',
        contactState: '',
        contactPostcode: '',
        contactHasAddressChanged: false,
        insertContactAddressManually: false,

        contactName: '',
        contactNumber: '',
        contactRelationship: '',
        citizenshipCode: '',
        offshoreFlag: ''
      },
      allowTitle: ['DR', 'PROF', 'APROF', 'REV', 'LT', 'HON'],
      legalIsOpen: false,
      personDetails: {},
      topCallout: '',
      prefilledData: {
        Title: '',
        'Legal Given names': '',
        'Legal Surname': '',
        'Date of birth': ''
      },
      tooltips: [],
      countryCodes: [],
      submitted: false,
      emergencyContactOptions: [],
      pronounsOptions: [],
      affirmedGenderOptions: [],
      clientError: false,
      serverError: false,
      showInvalidAddressModal: false,
      hasAttemptedToSave: false,
      showConfirmationModal: false,
      addressToConfirm: null,
      pendingSubmission: null,
      hasIgnoredPermanentValidationSuggestion: false,
      hasIgnoredContactValidationSuggestion: false
    }
  }

  componentDidMount() {
    Promise.all([getHelperTextForPage('Confirm Details'), getTooltipsForPage('Settings'), getPronounsDetails(), getAffirmedGenderDetails(), getReferences()])
      .then(([helperText, tooltips, pronouns, affirmedGender, { soneCountryCodeList = [], soneEmergencyContactCodeList = [] }]) => {
        this.props.fetchPersonalDetails()
        this.setState({
          topCallout: helperText.length > 0 ? helperText[0].attributes.body.value : this.state.topCallout,
          tooltips: tooltips,
          pronounsOptions: pronouns.referenceCodes,
          affirmedGenderOptions: affirmedGender.referenceCodes,
          countryCodes: soneCountryCodeList,
          emergencyContactOptions: soneEmergencyContactCodeList,
          ...this.initialiseForm(this.props.personalDetails, this.state.countryCodes),
          serverError: false,
          clientError: false
        })
      })
      .catch(error => {
        if (error.response && (error.response.status === 500 || error.response.status === 502)) {
          this.setState({
            loading: false,
            serverError: true
          })
        } else {
          this.setState({
            loading: false,
            clientError: true
          })
        }
      })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.receivedAt !== null && prevProps.receivedAt !== this.props.receivedAt) {
      this.setState({
        ...this.initialiseForm(this.props.personalDetails, this.state.countryCodes)
      })
    }
  }

  initialiseForm = (personalDetails, countryCodes = []) => {
    var prefilledTitleData = {}
    if (this.state.allowTitle.some(allowTitle => allowTitle.toLowerCase() === personalDetails.title.toLowerCase())) {
      prefilledTitleData = {
        Title: personalDetails.title
      }
    }
    return {
      form: {
        ...this.state.form,
        ...this.mergeStudentDetails(personalDetails, countryCodes),
        offshoreFlag: this.props.isOffshoreFlag
      },
      formLoaded: true,

      prefilledData: {
        ...prefilledTitleData,
        'Legal Given names': personalDetails.legalFirstName,
        'Legal Surname': personalDetails.legalLastName,
        'Date of birth': new Date(personalDetails.dateOfBirth).toLocaleDateString('en-AU', { timeZone: 'Australia/Melbourne' }, dateFormat)
      },
      personDetails: {
        ...personalDetails,
        address: personalDetails.addresses.map(address => {
          let keys = Object.keys(address)

          keys.forEach(key => {
            if (address[key] === null) {
              address[key] = ''
            }
          })
          return address
        })
      }
    }
  }

  validateExistingAddress = ({ addressLine1 = '', addressLine2 = '', addressLine3 = '', city = '', state = '', postCode = '', country = '' }) => {
    const addressSearch = addressLine1 + ' ' + addressLine2 + ' ' + addressLine3 + ', ' + city + ' ' + state + ' ' + postCode

    return postAddressSearch(country, addressSearch).then(({ confidence, suggestions }) => {
      if (confidence === AddressMatchTypes.VERIFIED_MATCH && suggestions.length === 1) {
        return suggestions[0]
      }
      return null
    })
  }

  handleSubmit = ({form, valid, errors}) => {
    const { hasAttemptedToSave, hasIgnoredPermanentValidationSuggestion, hasIgnoredContactValidationSuggestion, excludedCountries } = this.state

    const isPermanentExcluded = excludedCountries.some(excludedCountry => excludedCountry.countryCode === form.permanentCountry)
    const isContactExcluded = excludedCountries.some(excludedCountry => excludedCountry.countryCode === form.contactCountry)

    const isPermanentAddressValid = form.permanentValidationStatus === AddressValidationStatus.VALIDATED
    const isContactAddressValid = form.contactValidationStatus === AddressValidationStatus.VALIDATED

    const permanentAddressFields = getPermanentAddressFields(form)
    const contactAddressFields = getContactAddressFields(form)
    const previousPermanentAddressFields = getPermanentAddressFields(this.state.form)
    const previousContactAddressFields = getContactAddressFields(this.state.form)

    const isSameContactAddress = isSameAddress(previousContactAddressFields, contactAddressFields)
    const isSamePermanentAddress = isSameAddress(previousPermanentAddressFields, permanentAddressFields)

    const addressesChanged =
      !isSameContactAddress ||
      !isSamePermanentAddress ||
      form.insertPermanentAddressManually !== this.state.form.insertPermanentAddressManually ||
      form.insertContactAddressManually !== this.state.form.insertContactAddressManually

    if (addressesChanged) {
      this.setState({
        hasIgnoredPermanentValidationSuggestion: false,
        hasIgnoredContactValidationSuggestion: false,
        hasAttemptedToSave: false
      })
    }

    const promises = []
    let foundAddressToConfirm = null

    if (!isPermanentExcluded && ((!isPermanentAddressValid && !hasIgnoredPermanentValidationSuggestion) || (!isSamePermanentAddress && !isPermanentAddressValid))) {
      promises.push(
        this.validateExistingAddress(permanentAddressFields).then(result => {
          if (result) {
            foundAddressToConfirm = { type: 'permanent', searchResult: result }
            return true
          }
          return false
        })
      )
    }

    if (
      !isContactExcluded &&
      (
        (!isContactAddressValid && !form.contactAddressSameAsPermanentAddress && !hasIgnoredContactValidationSuggestion) ||
        (!isSameContactAddress && !isContactAddressValid && !form.contactAddressSameAsPermanentAddress)
      )
    ) {
      promises.push(
        this.validateExistingAddress(contactAddressFields).then(result => {
          if (result) {
            foundAddressToConfirm = { type: 'contact', searchResult: result }
            return true
          }
          return false
        })
      )
    }

    Promise.all(promises).then(results => {
      if (foundAddressToConfirm) {
        this.setState({
          addressToConfirm: foundAddressToConfirm,
          showConfirmationModal: true,
          pendingSubmission: { form, valid, errors },
          form: { ...form }
        })
        return
      }

      if (valid) {
        const shouldShowWarning = (!isPermanentExcluded && !isPermanentAddressValid) || (!form.contactAddressSameAsPermanentAddress && !isContactExcluded && !isContactAddressValid)

        if (!shouldShowWarning || (hasAttemptedToSave && !addressesChanged)) {
          this.handlePutRequest(form)
        } else {
          this.setState({
            showInvalidAddressModal: true,
            hasAttemptedToSave: true,
            form: form
          })
        }
      } else {
        const failedFieldName = Object.keys(errors).find(errorKey => errors[errorKey].length > 0)

        if (failedFieldName) {
          const failedField = window.document.querySelector(`[name=${failedFieldName}]`)
          if (failedField && failedField.scrollIntoView) {
            failedField.scrollIntoView({
              behavior: 'smooth'
            })
          } else {
            window.scrollTo(0, 0)
          }
        } else {
          window.scrollTo(0, 0)
        }
      }
    })
  }

  handleModalConfirm = () => {
    const { addressToConfirm, form, pendingSubmission } = this.state

    this.setState({ showConfirmationModal: false }, () => {
      postValidateAddress(
        addressToConfirm.searchResult.globalAddressKey,
        addressToConfirm.type === AddressType.Permanent ? pendingSubmission.form.permanentCountry : pendingSubmission.form.contactCountry
      )
        .then(validatedAddress => {
          if (validatedAddress) {
            const updatedAddress = this.handleAddressValidation(validatedAddress, addressToConfirm.type)

            // Create the updated form state
            const updatedForm = { ...form, ...updatedAddress }

            // Create updated pending submission
            const updatedPendingSubmission = {
              ...pendingSubmission,
              form: { ...pendingSubmission.form, ...updatedAddress }
            }

            return new Promise(resolve => {
              this.setState(
                {
                  form: updatedForm,
                  pendingSubmission: updatedPendingSubmission,
                  addressToConfirm: null
                },
                () => {
                  if (this.settingsFormRef && this.settingsFormRef.updateState) {
                    this.settingsFormRef.updateState(this.state.form)
                  }

                  document.body.style.overflowY = 'auto'
                  document.body.style.overflowX = 'hidden'
                  document.documentElement.style.overflowY = 'auto'
                  document.documentElement.style.overflowX = 'hidden'

                  resolve(updatedPendingSubmission)
                }
              )
            })
          }
        })
        .then(updatedPendingSubmission => {
          if (updatedPendingSubmission) {
            this.handleSubmit(updatedPendingSubmission)
          }
        })
    })
  }

  handleModalCancel = addressType => {
    const { pendingSubmission, hasIgnoredContactValidationSuggestion, hasIgnoredPermanentValidationSuggestion } = this.state

    const updatedState = {
      showConfirmationModal: false,
      addressToConfirm: null,
      form: pendingSubmission ? pendingSubmission.form : this.state.form,
      hasIgnoredPermanentValidationSuggestion: addressType === 'permanent' ? true : hasIgnoredPermanentValidationSuggestion,
      hasIgnoredContactValidationSuggestion: addressType === 'contact' ? true : hasIgnoredContactValidationSuggestion
    }

    // If we have a pending submission, update it with the ignored flags
    if (pendingSubmission) {
      updatedState.pendingSubmission = {
        ...pendingSubmission,
        form: updatedState.form,
        hasIgnoredPermanentValidationSuggestion: updatedState.hasIgnoredPermanentValidationSuggestion,
        hasIgnoredContactValidationSuggestion: updatedState.hasIgnoredContactValidationSuggestion
      }
    }

    this.setState(updatedState, () => {
      document.body.style.overflowY = 'auto'
      document.body.style.overflowX = 'hidden'
      document.documentElement.style.overflowY = 'auto'
      document.documentElement.style.overflowX = 'hidden'

      if (pendingSubmission) {
        // Use the updated pending submission from state
        this.handleSubmit(this.state.pendingSubmission)
      }
    })
  }

  handleAddressValidation = ({ addressLine1, addressLine2, addressLine3, city, state, postCode, country, longitude, latitude, verificationDate, validationStatus }, type) => {
    if (type === 'permanent') {
      return {
        permanentAddressLine1: addressLine1,
        permanentAddressLine2: addressLine2,
        permanentAddressLine3: addressLine3,
        permanentSuburb: city,
        permanentState: state,
        permanentPostcode: postCode,
        permanentLatitude: longitude || 0,
        permanentLongitude: latitude || 0,
        permanentVerificationDate: verificationDate || '',
        permanentValidationStatus: validationStatus,
        insertPermanentAddressManually: false
      }
    } else {
      return {
        contactAddressLine1: addressLine1,
        contactAddressLine2: addressLine2,
        contactAddressLine3: addressLine3,
        contactSuburb: city,
        contactState: state,
        contactPostcode: postCode,
        contactLatitude: longitude || 0,
        contactLongitude: latitude || 0,
        contactVerificationDate: verificationDate || '',
        contactValidationStatus: validationStatus,
        insertContactAddressManually: false
      }
    }
  }
  
  handlePhoneInformation = (phoneNumber, type, isInvalid = false) => {
    let phone = this.state.personDetails.phones.find(phone => phone.phoneType == type);

    return {
      phoneType: type,
      phoneNumber: phoneNumber, 
      isInvalid: isInvalid, 
      isPreferredSms: isInvalid ? false: phone && phone.isPreferredSms ? phone.isPreferredSms: false, 
      isPreferredVoice: isInvalid ? false: phone && phone.isPreferredVoice ? phone.isPreferredVoice: false
    }
  }

  handlePutRequest = form => {
    let originalPersonalDetails = this.state.personDetails
    let mobileContact = originalPersonalDetails.phones.find(phone => phone.phoneType == Phone.MOBILE);
    let homeContact = originalPersonalDetails.phones.find(phone => phone.phoneType == Phone.HOME);

    let homePhoneNumberStripped = stripPhoneNumber(form.homePhoneNumber)
    let contactMobilePhoneNumberStripped = stripPhoneNumber(form.mobileNumber)

    let homePhoneInvalid = homePhoneNumberStripped === "" ? true : false

    let homePhone = homePhoneInvalid ? 
      (homeContact && homeContact.phoneNumber) ? 
        this.handlePhoneInformation(homeContact.phoneNumber, Phone.HOME, homePhoneInvalid) 
        : this.handlePhoneInformation(null, Phone.HOME, homePhoneInvalid)  
      : this.handlePhoneInformation(homePhoneNumberStripped, Phone.HOME, homePhoneInvalid);

    let mobilePhone = (mobileContact && mobileContact.phoneNumber === contactMobilePhoneNumberStripped) ?
      mobileContact : 
      this.handlePhoneInformation(contactMobilePhoneNumberStripped, Phone.MOBILE, false);
    
    let guardianLvls = this.state.personDetails.studentGuardiansEduLvl.filter(({ sequenceNumber }) => sequenceNumber === 1 || sequenceNumber === 2)
    let addresses = this.reconcileAddresses(this.state.personDetails.addresses, form)

    let chosenFirstName = form.chosenFirstName ?  normalizeWhitespace(form.chosenFirstName) : ""
    let chosenLastName = form.chosenLastName ? normalizeWhitespace(form.chosenLastName) : ""

    let newPersonalDetails = {
      ...this.state.personDetails,
      chosenFirstName: chosenFirstName,
      chosenLastName: chosenLastName,
      preferredName: normalizeWhitespace(form.preferredName),
      chosenPronouns: form.chosenPronouns,
      chosenAffirmedGender: form.chosenAffirmedGender,
      contactPersonalEmail: form.emailAddress,
      studentGuardiansEduLvl: guardianLvls,
      emergencyContactName: normalizeWhitespace(form.contactName),
      emergencyContactMobilePhone: form.contactNumber,
      emergencyContactRelationshipCode: form.contactRelationship,
      phones : [mobilePhone, homePhone].filter(contact => contact.phoneNumber !== null),
      addresses: addresses
    }

    this.setState({
      saving: true,
      form: {
        ...form
      }
    })

    putPersonalDetails(newPersonalDetails)
      .then(() => {
        this.handleSuccess()
        this.props.refetchPersonalDetails()
      })
      .catch(() => {
        this.handleError('Unable to save personal details.')
      })
  }

  handleSuccess = () => {
    this.setState({
      saving: false,
      submitted: true
    })
  }

  handleError = error => {
    alert('Unable to save personal details.')
    this.setState({
      saving: false,
      submitted: false
    })
  }

  invalidateAddress = address => {
    return {
      ...address,
      isInvalid: true,
      isPreferred: false
    }
  }

  createAddress = (addressType, form) => {
    return {
      ...form,
      addressType: addressType
    }
  }

  mapToAddress = (address, form, isPreferred) => {
    let updatedAddress = {
      ...address,
      ...form
    }

    updatedAddress.isPreferred = isPreferred
    if (isPreferred) {
      updatedAddress.isInvalid = false
    }

    return updatedAddress
  }

  reconcileAddresses = (originalAddresses = [], form) => {
    const internationalOnshoreStudent = isInternationalOnshoreStudent(form.stuCitizenCd, form.offshoreFlag)
    const skipContactAddress = internationalOnshoreStudent && form.knowsAustralianAddress === 'N'

    const contactAddress = originalAddresses.find(({ addressType }) => addressType === AddressType.Contact)
    const newContactAddress = form.contactAddressSameAsPermanentAddress ? getPermanentAddressFields(form) : getContactAddressFields(form)
    const isContactAddressPreferred = (!isSameAddress(contactAddress, newContactAddress) || contactAddress.isPreferred) && !skipContactAddress

    let updatedAddresses = originalAddresses.map(address => {
      
      if(address.addressType === AddressType.Semester && address.isPreferred ) {
        address.isPreferred = false
      }
      
      if (address.addressType === AddressType.Contact) {
        if (skipContactAddress) {
          return this.invalidateAddress(address)
        }

        return this.mapToAddress(address, newContactAddress, isContactAddressPreferred)
      }

      if (address.addressType === AddressType.Permanent) {
        return this.mapToAddress(address, getPermanentAddressFields(form), !isContactAddressPreferred)
      }

      return address
    })

    const permanentAddress = originalAddresses.find(address => address.addressType === AddressType.Permanent)
    if (!permanentAddress) {
      let permAddress = this.createAddress(AddressType.Permanent, getPermanentAddressFields(form))

      if (skipContactAddress) {
        permAddress.isPreferred = true
      }
      updatedAddresses = updatedAddresses.concat(permAddress)
    }

    const ctctAddress = originalAddresses.find(address => address.addressType === AddressType.Contact)
    if (!ctctAddress && !skipContactAddress) {
      let createdContactAddress = this.createAddress(AddressType.Contact, newContactAddress)
      createdContactAddress.isPreferred = true
      updatedAddresses = updatedAddresses.concat(createdContactAddress)
    }

    return updatedAddresses
  }

  mergeStudentDetails = (studentDetails, countryCodes = []) => {
    let formDetails = {}
    let mobileNumber = studentDetails.phones.find(phone => phone.phoneType == Phone.MOBILE);
    let homeNumber = studentDetails.phones.find(phone => phone.phoneType == Phone.HOME);

    formDetails.preferredName = studentDetails.preferredName || studentDetails.chosenFirstName || studentDetails.legalFirstName || ''

    formDetails.chosenFirstName = studentDetails.chosenFirstName || ''

    formDetails.chosenLastName = studentDetails.chosenLastName || ''

    formDetails.chosenPronouns = studentDetails.chosenPronouns || ''

    formDetails.chosenAffirmedGender = studentDetails.chosenAffirmedGender || ''

    formDetails.mobileNumber = mobileNumber ? `${mobileNumber.phoneNumber}` : ''

    formDetails.homePhoneNumber = homeNumber && !homeNumber.isInvalid ?`${homeNumber.phoneNumber}` : ''

    formDetails.emailAddress = studentDetails.contactPersonalEmail ? studentDetails.contactPersonalEmail : ''

    formDetails.stuCitizenCd = studentDetails.stuCitizenCd

    const permanentAddress = studentDetails.addresses.find(({ addressType, isInvalid }) => addressType === AddressType.Permanent && !isInvalid)

    if (permanentAddress) {
      formDetails = {
        ...formDetails,
        ...mergePermanentDetails(permanentAddress)
      }
    }

    const contactAddress = studentDetails.addresses.find(({ addressType, isInvalid }) => addressType === AddressType.Contact && !isInvalid)

    if (contactAddress) {
      formDetails = {
        ...formDetails,
        knowsAustralianAddress: contactAddress.country === Country.Australia ? 'Y' : 'N',
        ...mergeContactDetails(contactAddress)
      }
    }

    formDetails.contactAddressSameAsPermanentAddress = isSameAddress(permanentAddress, contactAddress)

    formDetails.contactName = studentDetails.emergencyContactName || ''
    formDetails.contactNumber = studentDetails.emergencyContactMobilePhone || ''
    formDetails.contactRelationship = studentDetails.emergencyContactRelationshipCode || ''

    return formDetails
  }

  toggleLegal = () => {
    this.setState({
      legalIsOpen: !this.state.legalIsOpen
    })
  }

  handleCloseInvalidAddressModal = () => {
    this.setState({
      showInvalidAddressModal: false
    })
  }

  generateMessageDiv = (message = 'Your response has been successfully updated, thank you. You will receive further information via email') => {
    return (
      <div className="row">
        <div className="col-xs-12">
          <div className="empty-state-container empty-state-container--default">
            <h2>No content found</h2>
            <p className="txt-lg">{message}</p>
          </div>
        </div>
      </div>
    )
  }

  vuHQLink = () => {
    return (
      <a className="txt-link" target="_blank" href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres">
        VUHQ
      </a>
    )
  }

  render() {
    const { showConfirmationModal, addressToConfirm, showInvalidAddressModal, form } = this.state
    if (!this.state.formLoaded && !this.state.serverError && !this.state.clientError) {
      return (
        <div className="page">
          <div className="row">
            <div className="col-xs-12">
              <div className="settings-container">
                <Loading />
              </div>
            </div>
          </div>
        </div>
      )
    } else if (this.state.serverError) {
      return (
        <div className="row">
          <div className="col-xs-12">
            <div className="empty-state-container empty-state-container--default">
              <p className="txt-lg">
                We seem to be having technical difficulties, please refresh your browser, and try again. If you continue to have difficulties, please contact {this.vuHQLink()} for
                assistance.
              </p>
            </div>
          </div>
        </div>
      )
    } else if (this.state.clientError) {
      return (
        <div className="row">
          <div className="col-xs-12">
            <div className="empty-state-container empty-state-container--default">
              <p className="txt-lg">Unable to load personal details, please contact {this.vuHQLink()}.</p>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="page">
        {showConfirmationModal && addressToConfirm && (
          <ConfirmationModal
            className="modal-lg"
            isOpen={showConfirmationModal}
            title="Address Confirmation"
            handleCloseModal={this.handleCloseModal}
            handleCancel={() => this.handleModalCancel(addressToConfirm.type)}
            handleConfirmation={this.handleModalConfirm}
          >
            <div className="my-20">
              <p>We noticed that your {addressToConfirm.type} address has not been verified. We found a potential match — can you confirm if the address below is correct?</p>
              <p>
                <b>{addressToConfirm.searchResult.address}</b>
              </p>
            </div>
          </ConfirmationModal>
        )}
        <Modal
          className={'modal modal-lg'}
          isOpen={showInvalidAddressModal}
          handleCloseModal={() => this.handleCloseInvalidAddressModal()}
          title={'It seems you have an unverified address.'}
          showConfirmationButton={true}
          buttonText="I understand"
        >
          <div className="my-20">
            <p>
              Please note that your
              {form.permanentValidationStatus !== AddressValidationStatus.VALIDATED && form.contactValidationStatus !== AddressValidationStatus.VALIDATED
                ? ' permanent and contact addresses '
                : form.permanentValidationStatus !== AddressValidationStatus.VALIDATED
                ? ' permanent address '
                : form.contactValidationStatus !== AddressValidationStatus.VALIDATED
                ? ' contact address '
                : null}
              could not be automatically verified. To avoid incorrect information in your student record, please try again using the 'Find Address' field to ensure we can verify your address
              correctly. If you're unable to find your address, you may still proceed manually with your changes by clicking 'Save' again.
            </p>
          </div>
        </Modal>
        <div className="row">
          <div className="col-xs-12">
            <div className="settings-container show-pdf-icon">
              <HelpText tag={'h2'} text={'Personal details'} toolTip={getTooltipBySlug('personal-details', this.state.tooltips)} />

              <div>
                <div onClick={() => this.toggleLegal()}>
                  <h2>
                    Legal details
                    {this.state.legalIsOpen ? <ExpandLess /> : <ExpandMore />}
                  </h2>
                </div>
                {this.state.legalIsOpen && <CalloutBox topCallout={this.state.topCallout} data={this.state.prefilledData} />}
              </div>
              
              {!this.state.formLoaded ? (
                <Loading />
              ) : (
                <SettingsForm
                  formDetails={this.state.form}
                  saving={this.state.saving}
                  handleCloseInvalidAddressModal={this.handleCloseInvalidAddressModal}
                  hasAttemptedToSave={this.state.hasAttemptedToSave}
                  autofillAddresses={this.state.personDetails.addresses}
                  countryCodes={this.state.countryCodes}
                  excludedCountries={this.state.excludedCountries}
                  emergencyContactOptions={this.state.emergencyContactOptions}
                  pronounsOptions={this.state.pronounsOptions}
                  affirmedGenderOptions={this.state.affirmedGenderOptions}
                  onSubmit={this.handleSubmit}
                  formSubmitted={this.state.submitted}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Settings)
)
